const ACCOUNT_CONFIRMATION_CONSTANTS = {
  ACCOUNT_CONFIRMATION_FORM: 'AccountConfirmationForm',
  VALIDATE_MEMBER: 'VALIDATE_MEMBER',
  ACCOUNT_CONFIRMATION_FAILED: 'ACCOUNT_CONFIRMATION_FAILED',
  ACCOUNT_CONFIRMATION_REQUEST: 'ACCOUNT_CONFIRMATION_REQUEST',
  ACCOUNT_CONFIRMATION_SUCCESS: 'ACCOUNT_CONFIRMATION_SUCCESS',
  RESET_ACCOUNT_CONFIRMATION: 'RESET_ACCOUNT_CONFIRMATION',
  ACCOUNT_VALID: 'VALID',
  ACCOUNT_INVALID: 'INVALID',
};

export default ACCOUNT_CONFIRMATION_CONSTANTS;
